import SchoolInformation from "../pages/curriculum/school-information/school-information";
import SetupClassRoutine from "../pages/curriculum/setup-class-routine/setup-class-routine";
import Subjects from "../pages/curriculum/subjects/subjects";
import Dashboard from "../pages/dashboard/dashboard";
import InstitutionDetails from "../pages/institutions/components/institution-details/institution-details";
import InstitutionForm from "../pages/institutions/components/institution-form/institution-form";
import Institutions from "../pages/institutions/institutions";
import ProductDemoRequests from "../pages/product-demo-requests/product-demo-requests";
import PublishParentForm from "../pages/publish-parent-form/publish-parent-form";
import SchoolStatistics from "../pages/school-statistics/school-statistics";
import Settings from "../pages/settings/settings";
import Staff from "../pages/staff/staff";
import StudentDetails from "../pages/students/components/student-details/student-details";
import StudentForm from "../pages/students/components/student-form/student-form";
import StudentList from "../pages/students/components/student-list/student-list";
import Students from "../pages/students/students";
import InstitutionOwners from "../pages/super-admin/institution-owners/institution-owners";
import TeacherDetails from "../pages/teachers/components/teacher-details/teacher-details";
import TeacherForm from "../pages/teachers/components/teacher-form/teacher-form";
import TeacherList from "../pages/teachers/components/teacher-list/teacher-list";
import Teachers from "../pages/teachers/teachers";
import UserRoleManagement from "../pages/user-role-management/user-role-management";
import ScheduleExamination from "../pages/schedule-examination/schedule-examination";
import ReportCardManagement from "../pages/curriculum/report-card-management/ReportCardManagement";
import RoutesConstant from "./routes";
import Announcement from "../pages/announcement/announcement";
import HolidayLeave from "../pages/holiday-leave/holiday-leave";
import StudentAttendance from "../pages/attendance/student-attendance/student-attendance";
import Chat from "../pages/communication/communication";
import TeacherAttendance from "../pages/attendance/teacher-attendance/teacher-attendance";
import NewsLetter from "../pages/newsletter/newsletter";
import NewsLetterForm from "../pages/newsletter/components/newsletter-form/newsletter-form";
import Support from "../pages/support/support";
import CustomerSupport from "../pages/support/customer-support/customer-support";
import Event from "../pages/event/event";
import ContactQueries from "../pages/contact-queries/contact-queries";
import StudentPromotion from "../pages/curriculum/student-promotion/student-promotion";
import ResetPasswordFirstLogin from "../pages/auth/reset-password-first-login/reset-password-first-login";

const protectedRoutes = [
  {
    id: "dashboard",
    path: RoutesConstant.DASHBOARD,
    component: Dashboard,
    title: "Dashboard",
  },
  {
    id: "institutions",
    path: RoutesConstant.INSTITUTIONS,
    component: Institutions,
    title: "Institutions",
  },
  {
    id: "institution-owners",
    path: RoutesConstant.INSTITUTION_OWNERS,
    component: InstitutionOwners,
    title: "Institutions Owners",
  },
  {
    id: "institution-details",
    path: RoutesConstant.INSTITUTION_DETAILS,
    component: InstitutionDetails,
    title: "Institution Details",
  },
  {
    id: "institution-form",
    path: RoutesConstant.INSTITUTION_FORM,
    component: InstitutionForm,
    title: "Institution Form",
  },
  {
    id: "demo-requests",
    path: RoutesConstant.PRODUCT_DEMO,
    component: ProductDemoRequests,
    title: "Product Demo",
  },
  {
    id: "publish-parent-form",
    path: RoutesConstant.PUBLISH_PARENT_FORM,
    component: PublishParentForm,
    title: "Parent Form",
  },
  {
    id: "user-role-management",
    path: RoutesConstant.USER_ROLE_MANAGEMENT,
    component: UserRoleManagement,
    title: "User Role Management",
  },
  {
    id: "school-statistics",
    path: RoutesConstant.SCHOOL_STATISTICS,
    component: SchoolStatistics,
    title: "School Statistics ",
  },
  {
    id: "students",
    path: RoutesConstant.STUDENTS,
    component: Students,
    title: "Students",
  },
  {
    id: "student-details",
    path: RoutesConstant.STUDENT_DETAILS,
    component: StudentDetails,
    title: "Student Details",
  },
  {
    id: "student-form",
    path: RoutesConstant.STUDENT_FORM,
    component: StudentForm,
    title: "Student Form",
  },
  {
    id: "staff",
    path: RoutesConstant.STAFF,
    component: Staff,
    title: "Staff",
  },
  {
    id: "settings",
    path: RoutesConstant.SETTINGS,
    component: Settings,
    title: "Settings",
  },
  {
    id: "student-list",
    path: RoutesConstant.STUDENT_LIST,
    component: StudentList,
    title: "Students",
  },
  {
    id: "teachers",
    path: RoutesConstant.TEACHERS,
    component: Teachers,
    title: "Teachers",
  },
  {
    id: "teacher-list",
    path: RoutesConstant.TEACHER_LIST,
    component: TeacherList,
    title: "Teachers",
  },
  {
    id: "teacher-details",
    path: RoutesConstant.TEACHER_DETAILS,
    component: TeacherDetails,
    title: "Teacher Details",
  },
  {
    id: "teacher-form",
    path: RoutesConstant.TEACHER_FORM,
    component: TeacherForm,
    title: "Teacher Form",
  },
  {
    id: "subjects",
    path: RoutesConstant.SUBJECTS,
    component: Subjects,
    title: "Subjects",
  },
  {
    id: "attendance-register",
    path: RoutesConstant.ATTENDANCE_REGISTER,
    component: TeacherDetails,
    title: "Attendance Register",
  },
  {
    id: "setup-class-routine",
    path: RoutesConstant.SETUP_CLASS_ROUTINE,
    component: SetupClassRoutine,
    title: "Setup Class & Routine",
  },
  {
    id: "school-information",
    path: RoutesConstant.SCHOOL_INFORMATION,
    component: SchoolInformation,
    title: "School Information",
  },
  {
    id: "student-attendance",
    path: RoutesConstant.STUDENT_ATTENDANCE,
    component: StudentAttendance,
    title: "School Attendance",
  },
  {
    id: "teacher-attendance",
    path: RoutesConstant.TEACHER_ATTENDANCE,
    component: TeacherAttendance,
    title: "Teacher Attendance",
  },
  {
    id: "schedule-examination",
    path: RoutesConstant.SCHEDULE_EXAMINATION,
    component: ScheduleExamination,
    title: "Schedule Examination",
  },
  {
    id: "report-card-management",
    path: RoutesConstant.REPORT_CARD_MANAGEMENT,
    component: ReportCardManagement,
    title: "Report Card Management",
  },
  {
    id: "announcement",
    path: RoutesConstant.ANNOUNCEMENT,
    component: Announcement,
    title: "Announcement",
  },
  {
    id: "holiday-leave",
    path: RoutesConstant.HOLIDAY_LEAVE,
    component: HolidayLeave,
    title: "Holiday & Leave",
  },
  {
    id: "event",
    path: RoutesConstant.EVENT,
    component: Event,
    title: "Event",
  },
  {
    id: "communication",
    path: RoutesConstant.CHAT,
    component: Chat,
    title: "Chat",
  },
  {
    id: "newsletter",
    path: RoutesConstant.NEWSLETTER,
    component: NewsLetter,
    title: "Newsletter",
  },
  {
    id: "newsletter-form",
    path: RoutesConstant.NEWSLETTER_FORM,
    component: NewsLetterForm,
    title: "Newsletter Form",
  },
  {
    id: "support",
    path: RoutesConstant.SUPPORT,
    component: Support,
    title: "Support",
  },
  {
    id: "support-chat",
    path: RoutesConstant.SUPPORT_CHAT,
    component: Support,
    title: "Support Chat",
  },
  {
    id: "customer-support",
    path: RoutesConstant.CUSTOMER_SUPPORT,
    component: CustomerSupport,
    title: "Customer Support",
  },
  {
    id: "contact-queries",
    path: RoutesConstant.CONTACT_QUERIES,
    component: ContactQueries,
    title: "Contact Queries",
  },
  {
    id: "student-promotion",
    path: RoutesConstant.STUDENT_PROMOTION,
    component: StudentPromotion,
    title: "Student Promotion",
  },
  {
    id: "reset-password-first-login",
    path: RoutesConstant.RESET_PASSWORD_FIRST_LOGIN,
    component: ResetPasswordFirstLogin,
    title: "Reset Password",
  },
];

export default protectedRoutes;
